import { DEFAULT_CYCLE } from '@teetsh/app/src/containers/scholarSystem';

export const emptyBo = {
  matiere: [],
  competence: [],
  cycle: DEFAULT_CYCLE,
  domaine: [],
  goals: [],
};

export default emptyBo;
